/* DENSA — SİTE GENELİ BİLDİRİM (TOAST) ALTYAPISI v2 — 8 Ağu 2026
   v2 — MARKA KİTABI UYUMU: zemin artık ALTIN DEĞİL.
     Marka kuralı: şampanya altını "varak, ince çizgi, detay — ASLA GENİŞ YÜZEY".
     v1.1'de zemini altın yapmıştım (yeşil header üzerinde görünsün diye) — renk değerini
     düzeltmek yetmiyordu, KULLANIM da kurala aykırıydı.
     YENİ ÇÖZÜM: Sıcak Fildişi zemin (#F4EFE4) + İNCE ALTIN ÇERÇEVE (#AE9F7D 1px) +
     Densa Yeşili metin + altın ikon. Yeşil header'ın üzerine indiğinde açık zemin
     sayesinde net ayrışır; fildişi sayfada da altın çerçeve ve gölge onu ayırır.
     Böylece hem görünürlük hem marka kuralı karşılanıyor.
   TEK ÇAĞRI: densaBildir('Metin', 'kalp'|'sepet'|'link'|'bilgi')
   Otomatik bağlantı: 'cart:update' → "Ürün sepetinize eklendi" (tüm sepet düğmeleri tek yerden).
   İstek listesi bildirimi densa-istek snippet'inden çağrılır (yalnız EKLEMEDE).
   Erişilebilirlik: aria-live=polite · prefers-reduced-motion'da animasyonsuz. */
(function () {
  if (window.densaBildir) return;

  var IKON = {
    kalp: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>',
    sepet: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"/><path d="M14.608 12.563v5m2.5-2.5h-5"/></svg>',
    link: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7"/><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7"/></svg>',
    bilgi: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></svg>'
  };

  var STIL = ''
    + '.dbil-kap{position:fixed;top:0;right:0;z-index:2147482000;display:flex;flex-direction:column;'
    + 'align-items:flex-end;gap:10px;padding:18px 18px 0;pointer-events:none;max-width:min(92vw,420px)}'
    + '.dbil{display:flex;align-items:center;gap:12px;pointer-events:auto;'
    + 'background:#F4EFE4;color:#124034;border:1px solid #AE9F7D;'
    + 'border-radius:3px;padding:13px 18px 13px 15px;box-shadow:0 16px 44px rgba(18,64,52,.28);'
    + 'font-family:"DENSA Sans","Avenir Next",Avenir,"Segoe UI",Roboto,Arial,sans-serif;font-size:13.5px;'
    + 'font-weight:500;letter-spacing:.02em;line-height:1.45;'
    + 'transform:translateY(-14px);opacity:0;transition:transform .42s cubic-bezier(.22,.61,.36,1),opacity .42s ease}'
    + '.dbil.acik{transform:none;opacity:1}'
    + '.dbil.kapaniyor{transform:translateY(-10px);opacity:0}'
    + '.dbil svg{width:18px;height:18px;flex:0 0 auto;color:#AE9F7D}'
    + '.dbil .dbil-ikon.dolu svg{fill:#AE9F7D;stroke:none}'
    + '@media(max-width:749px){.dbil-kap{left:0;right:0;align-items:center;padding:12px 12px 0;max-width:none}'
    + '.dbil{width:calc(100vw - 24px);max-width:420px}}'
    + '@media(prefers-reduced-motion:reduce){.dbil{transition:opacity .2s ease;transform:none}'
    + '.dbil.kapaniyor{transform:none}}';

  function kapsayici() {
    var k = document.getElementById('dbilKap');
    if (k) return k;
    var s = document.createElement('style'); s.textContent = STIL; document.head.appendChild(s);
    k = document.createElement('div');
    k.id = 'dbilKap'; k.className = 'dbil-kap';
    k.setAttribute('role', 'status');
    k.setAttribute('aria-live', 'polite');
    document.body.appendChild(k);
    return k;
  }

  var acikOlanlar = 0;
  window.densaBildir = function (metin, tip, sure) {
    if (!metin) return;
    var k = kapsayici();
    if (acikOlanlar >= 3) { var ilk = k.firstChild; if (ilk) kapat(ilk); }
    var t = tip && IKON[tip] ? tip : 'bilgi';
    var el = document.createElement('div');
    el.className = 'dbil';
    el.innerHTML = '<span class="dbil-ikon' + (t === 'kalp' ? ' dolu' : '') + '">' + IKON[t] + '</span><span>' + metin + '</span>';
    k.appendChild(el);
    acikOlanlar++;
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('acik'); }); });
    var z = setTimeout(function () { kapat(el); }, sure || 2600);
    el.addEventListener('click', function () { clearTimeout(z); kapat(el); });
  };

  function kapat(el) {
    if (!el || el.dataset.kapandi) return;
    el.dataset.kapandi = '1';
    el.classList.add('kapaniyor');
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); acikOlanlar = Math.max(0, acikOlanlar - 1); }, 460);
  }

  document.addEventListener('cart:update', function (e) {
    var d = e && e.detail;
    if (d && d.data && d.data.didError) return;
    window.densaBildir('Ürün sepetinize eklendi', 'sepet');
  });
})();
